var map = {
	"./eduqasAuthors": [
		9914,
		9914
	],
	"./eduqasAuthors.json": [
		9914,
		9914
	],
	"./eduqasSubjects": [
		323,
		323
	],
	"./eduqasSubjects.json": [
		323,
		323
	],
	"./eduqasSubjects/Applied-Science-EN": [
		630,
		630
	],
	"./eduqasSubjects/Applied-Science-EN.json": [
		630,
		630
	],
	"./eduqasSubjects/Art-and-Design-EN": [
		5350,
		5350
	],
	"./eduqasSubjects/Art-and-Design-EN.json": [
		5350,
		5350
	],
	"./eduqasSubjects/Biology-EN": [
		4222,
		4222
	],
	"./eduqasSubjects/Biology-EN.json": [
		4222,
		4222
	],
	"./eduqasSubjects/Business-EN": [
		5882,
		5882
	],
	"./eduqasSubjects/Business-EN.json": [
		5882,
		5882
	],
	"./eduqasSubjects/Chemistry-EN": [
		77,
		77
	],
	"./eduqasSubjects/Chemistry-EN.json": [
		77,
		77
	],
	"./eduqasSubjects/Computer-Science-EN": [
		3287,
		3287
	],
	"./eduqasSubjects/Computer-Science-EN.json": [
		3287,
		3287
	],
	"./eduqasSubjects/Design-and-Technology-EN": [
		8508,
		8508
	],
	"./eduqasSubjects/Design-and-Technology-EN.json": [
		8508,
		8508
	],
	"./eduqasSubjects/Drama-EN": [
		7996,
		7996
	],
	"./eduqasSubjects/Drama-EN.json": [
		7996,
		7996
	],
	"./eduqasSubjects/English-Language---Literature-EN": [
		2088,
		2088
	],
	"./eduqasSubjects/English-Language---Literature-EN.json": [
		2088,
		2088
	],
	"./eduqasSubjects/English-Language-EN": [
		3083,
		3083
	],
	"./eduqasSubjects/English-Language-EN.json": [
		3083,
		3083
	],
	"./eduqasSubjects/English-Language-Literature-EN": [
		2297,
		2297
	],
	"./eduqasSubjects/English-Language-Literature-EN.json": [
		2297,
		2297
	],
	"./eduqasSubjects/English-Literature-EN": [
		4768,
		4768
	],
	"./eduqasSubjects/English-Literature-EN.json": [
		4768,
		4768
	],
	"./eduqasSubjects/Geography-EN": [
		2568,
		2568
	],
	"./eduqasSubjects/Geography-EN.json": [
		2568,
		2568
	],
	"./eduqasSubjects/History-EN": [
		1038,
		1038
	],
	"./eduqasSubjects/History-EN.json": [
		1038,
		1038
	],
	"./eduqasSubjects/Mathematics-EN": [
		5727,
		5727
	],
	"./eduqasSubjects/Mathematics-EN.json": [
		5727,
		5727
	],
	"./eduqasSubjects/Physics-EN": [
		4324,
		4324
	],
	"./eduqasSubjects/Physics-EN.json": [
		4324,
		4324
	],
	"./eduqasSubjects/Psychology-EN": [
		3840,
		3840
	],
	"./eduqasSubjects/Psychology-EN.json": [
		3840,
		3840
	],
	"./eduqasSubjects/Religious-Studies-EN": [
		3851,
		3851
	],
	"./eduqasSubjects/Religious-Studies-EN.json": [
		3851,
		3851
	],
	"./qualifications": [
		8363
	],
	"./qualifications.json": [
		8363
	],
	"./specItems/alevel-biology": [
		420
	],
	"./specItems/alevel-biology.json": [
		420
	],
	"./specItems/alevel-business": [
		5941
	],
	"./specItems/alevel-business.json": [
		5941
	],
	"./specItems/alevel-chemistry": [
		5355
	],
	"./specItems/alevel-chemistry.json": [
		5355
	],
	"./specItems/alevel-englang": [
		802
	],
	"./specItems/alevel-englang.json": [
		802
	],
	"./specItems/alevel-englit": [
		5808
	],
	"./specItems/alevel-englit.json": [
		5808
	],
	"./specItems/alevel-maths": [
		286
	],
	"./specItems/alevel-maths.json": [
		286
	],
	"./specItems/alevel-physics": [
		8230
	],
	"./specItems/alevel-physics.json": [
		8230
	],
	"./specItems/alevel-welsh-language": [
		1670
	],
	"./specItems/alevel-welsh-language.json": [
		1670
	],
	"./specItems/alevel-welsh-second": [
		4690
	],
	"./specItems/alevel-welsh-second.json": [
		4690
	],
	"./specItems/gcse-applied-science-double": [
		6914
	],
	"./specItems/gcse-applied-science-double.json": [
		6914
	],
	"./specItems/gcse-applied-science-single": [
		1280
	],
	"./specItems/gcse-applied-science-single.json": [
		1280
	],
	"./specItems/gcse-art": [
		5349
	],
	"./specItems/gcse-art.json": [
		5349
	],
	"./specItems/gcse-biology": [
		6575
	],
	"./specItems/gcse-biology.json": [
		6575
	],
	"./specItems/gcse-built-environment": [
		4848
	],
	"./specItems/gcse-built-environment.json": [
		4848
	],
	"./specItems/gcse-business": [
		4364
	],
	"./specItems/gcse-business.json": [
		4364
	],
	"./specItems/gcse-chemistry": [
		9247
	],
	"./specItems/gcse-chemistry.json": [
		9247
	],
	"./specItems/gcse-computer-sci": [
		447
	],
	"./specItems/gcse-computer-sci.json": [
		447
	],
	"./specItems/gcse-design-tech": [
		5835
	],
	"./specItems/gcse-design-tech.json": [
		5835
	],
	"./specItems/gcse-digital-tech": [
		3327
	],
	"./specItems/gcse-digital-tech.json": [
		3327
	],
	"./specItems/gcse-drama": [
		399
	],
	"./specItems/gcse-drama.json": [
		399
	],
	"./specItems/gcse-electronics": [
		5339
	],
	"./specItems/gcse-electronics.json": [
		5339
	],
	"./specItems/gcse-englang": [
		3955
	],
	"./specItems/gcse-englang.json": [
		3955
	],
	"./specItems/gcse-englit": [
		5833
	],
	"./specItems/gcse-englit.json": [
		5833
	],
	"./specItems/gcse-film": [
		1337
	],
	"./specItems/gcse-film.json": [
		1337
	],
	"./specItems/gcse-food": [
		425
	],
	"./specItems/gcse-food.json": [
		425
	],
	"./specItems/gcse-french": [
		8541
	],
	"./specItems/gcse-french.json": [
		8541
	],
	"./specItems/gcse-geography": [
		7662
	],
	"./specItems/gcse-geography.json": [
		7662
	],
	"./specItems/gcse-geology": [
		1055
	],
	"./specItems/gcse-geology.json": [
		1055
	],
	"./specItems/gcse-german": [
		8078
	],
	"./specItems/gcse-german.json": [
		8078
	],
	"./specItems/gcse-health-and-social-care": [
		5540
	],
	"./specItems/gcse-health-and-social-care.json": [
		5540
	],
	"./specItems/gcse-history": [
		7195
	],
	"./specItems/gcse-history.json": [
		7195
	],
	"./specItems/gcse-ict": [
		9084
	],
	"./specItems/gcse-ict.json": [
		9084
	],
	"./specItems/gcse-maths": [
		7619
	],
	"./specItems/gcse-maths.json": [
		7619
	],
	"./specItems/gcse-media": [
		2604
	],
	"./specItems/gcse-media.json": [
		2604
	],
	"./specItems/gcse-music": [
		8237
	],
	"./specItems/gcse-music.json": [
		8237
	],
	"./specItems/gcse-pe": [
		2275
	],
	"./specItems/gcse-pe.json": [
		2275
	],
	"./specItems/gcse-physics": [
		4547
	],
	"./specItems/gcse-physics.json": [
		4547
	],
	"./specItems/gcse-religious-studies": [
		5037
	],
	"./specItems/gcse-religious-studies.json": [
		5037
	],
	"./specItems/gcse-sociology": [
		8264
	],
	"./specItems/gcse-sociology.json": [
		8264
	],
	"./specItems/gcse-spanish": [
		1221
	],
	"./specItems/gcse-spanish.json": [
		1221
	],
	"./specItems/gcse-welsh-language": [
		4148
	],
	"./specItems/gcse-welsh-language.json": [
		4148
	],
	"./specItems/gcse-welsh-literature": [
		8740
	],
	"./specItems/gcse-welsh-literature.json": [
		8740
	],
	"./specItems/gcse-welsh-second": [
		1101
	],
	"./specItems/gcse-welsh-second.json": [
		1101
	],
	"./specItems/mfw-gcse-business": [
		4359
	],
	"./specItems/mfw-gcse-business.json": [
		4359
	],
	"./specItems/mfw-gcse-computer-sci": [
		9882
	],
	"./specItems/mfw-gcse-computer-sci.json": [
		9882
	],
	"./specItems/mfw-gcse-core-cymraeg": [
		9601
	],
	"./specItems/mfw-gcse-core-cymraeg.json": [
		9601
	],
	"./specItems/mfw-gcse-drama": [
		113
	],
	"./specItems/mfw-gcse-drama.json": [
		113
	],
	"./specItems/mfw-gcse-englitlang": [
		1201
	],
	"./specItems/mfw-gcse-englitlang.json": [
		1201
	],
	"./specItems/mfw-gcse-food": [
		5753
	],
	"./specItems/mfw-gcse-food.json": [
		5753
	],
	"./specItems/mfw-gcse-geography": [
		9488
	],
	"./specItems/mfw-gcse-geography.json": [
		9488
	],
	"./specItems/mfw-gcse-history": [
		6644
	],
	"./specItems/mfw-gcse-history.json": [
		6644
	],
	"./specItems/mfw-gcse-level-2-additional-core-cymraeg": [
		9170
	],
	"./specItems/mfw-gcse-level-2-additional-core-cymraeg.json": [
		9170
	],
	"./specItems/mfw-gcse-mathematics-and-numeracy": [
		2692
	],
	"./specItems/mfw-gcse-mathematics-and-numeracy.json": [
		2692
	],
	"./specItems/mfw-gcse-music": [
		2768
	],
	"./specItems/mfw-gcse-music.json": [
		2768
	],
	"./specItems/mfw-gcse-religious-studies": [
		4440
	],
	"./specItems/mfw-gcse-religious-studies.json": [
		4440
	],
	"./specItems/mfw-gcse-welsh-language-and-literature": [
		6973
	],
	"./specItems/mfw-gcse-welsh-language-and-literature.json": [
		6973
	],
	"./specItems/test-test": [
		7791
	],
	"./specItems/test-test.json": [
		7791
	],
	"./wjecAuthors": [
		2106,
		2106
	],
	"./wjecAuthors.json": [
		2106,
		2106
	],
	"./wjecSubjects": [
		8927,
		8927
	],
	"./wjecSubjects.json": [
		8927,
		8927
	],
	"./wjecSubjects/Applied-Science-EN": [
		1809,
		1809
	],
	"./wjecSubjects/Applied-Science-EN.json": [
		1809,
		1809
	],
	"./wjecSubjects/Art-and-Design-EN": [
		5619,
		5619
	],
	"./wjecSubjects/Art-and-Design-EN.json": [
		5619,
		5619
	],
	"./wjecSubjects/Astudiaethau-Crefyddol-CY": [
		1918,
		1918
	],
	"./wjecSubjects/Astudiaethau-Crefyddol-CY.json": [
		1918,
		1918
	],
	"./wjecSubjects/Bioleg-CY": [
		5336,
		5336
	],
	"./wjecSubjects/Bioleg-CY.json": [
		5336,
		5336
	],
	"./wjecSubjects/Biology-EN": [
		1010,
		1010
	],
	"./wjecSubjects/Biology-EN.json": [
		1010,
		1010
	],
	"./wjecSubjects/Business-EN": [
		3561,
		3561
	],
	"./wjecSubjects/Business-EN.json": [
		3561,
		3561
	],
	"./wjecSubjects/Busnes-CY": [
		9558,
		9558
	],
	"./wjecSubjects/Busnes-CY.json": [
		9558,
		9558
	],
	"./wjecSubjects/Celf-a-Dylunio-CY": [
		906,
		906
	],
	"./wjecSubjects/Celf-a-Dylunio-CY.json": [
		906,
		906
	],
	"./wjecSubjects/Cemeg-CY": [
		7719,
		7719
	],
	"./wjecSubjects/Cemeg-CY.json": [
		7719,
		7719
	],
	"./wjecSubjects/Chemistry-EN": [
		8026,
		8026
	],
	"./wjecSubjects/Chemistry-EN.json": [
		8026,
		8026
	],
	"./wjecSubjects/Computer-Science-EN": [
		6733,
		6733
	],
	"./wjecSubjects/Computer-Science-EN.json": [
		6733,
		6733
	],
	"./wjecSubjects/Cyfrifiadureg-CY": [
		4792,
		4792
	],
	"./wjecSubjects/Cyfrifiadureg-CY.json": [
		4792,
		4792
	],
	"./wjecSubjects/Cymraeg-Ail-Iaith-CY": [
		2290,
		2290
	],
	"./wjecSubjects/Cymraeg-Ail-Iaith-CY.json": [
		2290,
		2290
	],
	"./wjecSubjects/Cymraeg-CY": [
		2469,
		2469
	],
	"./wjecSubjects/Cymraeg-CY.json": [
		2469,
		2469
	],
	"./wjecSubjects/Daearyddiaeth-CY": [
		4813,
		4813
	],
	"./wjecSubjects/Daearyddiaeth-CY.json": [
		4813,
		4813
	],
	"./wjecSubjects/Design-and-Technology-EN": [
		4373,
		4373
	],
	"./wjecSubjects/Design-and-Technology-EN.json": [
		4373,
		4373
	],
	"./wjecSubjects/Drama-EN": [
		5206,
		8872
	],
	"./wjecSubjects/Drama-EN.json": [
		5206,
		8872
	],
	"./wjecSubjects/Dylunio-a-Thechnoleg-CY": [
		9850,
		9850
	],
	"./wjecSubjects/Dylunio-a-Thechnoleg-CY.json": [
		9850,
		9850
	],
	"./wjecSubjects/English-Language-EN": [
		10,
		10
	],
	"./wjecSubjects/English-Language-EN.json": [
		10,
		10
	],
	"./wjecSubjects/English-Language-Literature-EN": [
		4281,
		4281
	],
	"./wjecSubjects/English-Language-Literature-EN.json": [
		4281,
		4281
	],
	"./wjecSubjects/English-Literature-EN": [
		6564,
		6564
	],
	"./wjecSubjects/English-Literature-EN.json": [
		6564,
		6564
	],
	"./wjecSubjects/Ffiseg-CY": [
		8216,
		8216
	],
	"./wjecSubjects/Ffiseg-CY.json": [
		8216,
		8216
	],
	"./wjecSubjects/Geography-EN": [
		2582,
		2582
	],
	"./wjecSubjects/Geography-EN.json": [
		2582,
		2582
	],
	"./wjecSubjects/Gwyddoniaeth-Gymhwysol-CY": [
		6300,
		6300
	],
	"./wjecSubjects/Gwyddoniaeth-Gymhwysol-CY.json": [
		6300,
		6300
	],
	"./wjecSubjects/Hanes-CY": [
		3557,
		3557
	],
	"./wjecSubjects/Hanes-CY.json": [
		3557,
		3557
	],
	"./wjecSubjects/History-EN": [
		883,
		883
	],
	"./wjecSubjects/History-EN.json": [
		883,
		883
	],
	"./wjecSubjects/Mathemateg-CY": [
		6899,
		6899
	],
	"./wjecSubjects/Mathemateg-CY.json": [
		6899,
		6899
	],
	"./wjecSubjects/Mathematics-EN": [
		8281,
		8281
	],
	"./wjecSubjects/Mathematics-EN.json": [
		8281,
		8281
	],
	"./wjecSubjects/Physics-EN": [
		352,
		352
	],
	"./wjecSubjects/Physics-EN.json": [
		352,
		352
	],
	"./wjecSubjects/Psychology-EN": [
		7603,
		7603
	],
	"./wjecSubjects/Psychology-EN.json": [
		7603,
		7603
	],
	"./wjecSubjects/Religious-Studies-EN": [
		1541,
		1541
	],
	"./wjecSubjects/Religious-Studies-EN.json": [
		1541,
		1541
	],
	"./wjecSubjects/Saesneg-CY": [
		4295,
		4295
	],
	"./wjecSubjects/Saesneg-CY.json": [
		4295,
		4295
	],
	"./wjecSubjects/Seicoleg-CY": [
		8340,
		8340
	],
	"./wjecSubjects/Seicoleg-CY.json": [
		8340,
		8340
	],
	"./wjecSubjects/Welsh-EN": [
		3599,
		3599
	],
	"./wjecSubjects/Welsh-EN.json": [
		3599,
		3599
	],
	"./wjecSubjects/Welsh-Second-Language-EN": [
		6705,
		6705
	],
	"./wjecSubjects/Welsh-Second-Language-EN.json": [
		6705,
		6705
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3159;
module.exports = webpackAsyncContext;